import type { ReactNode } from 'react';

import type { Draggable } from '@dnd-kit/abstract';
import { DragOverlay } from '@dnd-kit/react';

type SortableOverlayProps = {
  children: ReactNode | ((source: Draggable) => ReactNode);
};

export function SortableOverlay({ children }: SortableOverlayProps) {
  return <DragOverlay dropAnimation={{ duration: 250 }}>{children}</DragOverlay>;
}
